import React, { useCallback } from 'react';
import { useTempState } from '@starflow/app/store';
import { isStarFlowModel } from '@shakkerai/pro-utils';
import { translate } from '@shakkerai/util-i18n';
import { fixHiresOptions } from '../../helpers';
import { PanelWrapper } from './wrapper';
import { GenerateCount } from './count';
import { GenerateSize, SizeInputGroup } from './size';
import { HiResEntry } from './hires';
import { GeneratorPanelFooter } from './footer';
import { Reference } from './reference';
import { Models } from './model';
import { AddOns } from './addons';
import { BaseParams } from './params';
import { Prompt } from './prompt';
import { ColorReference } from './colorReference';

export {
  PanelWrapper,
  GeneratorPanelFooter,
  GenerateCount,
  GenerateSize,
  SizeInputGroup,
  Reference,
  Prompt,
  Models,
  AddOns,
  BaseParams,
};

export const GeneratorPanel = React.memo(({ generator }) => {
  const isProMode = useTempState('globalMode') === 'pro';

  const handleSizeChange = useCallback(
    (data) => {
      if (data.width || data.height) {
        fixHiresOptions(generator.id, 'generateSize');
      }
    },
    [generator.id],
  );
  const isStarFlow = isStarFlowModel(generator);

  return (
    <PanelWrapper generator={generator} footer={<GeneratorPanelFooter generator={generator} />}>
      <div id="generator-panel" className="flex flex-col">
        <Models generator={generator} />

        {/* {!isStarFlow && ( */}
        <>
          <div className="-mx-4 my-3.5 border-t border-[#efefef]" />
          <Reference generator={generator} />
        </>
        {/* )} */}

        {isStarFlow && (
          <>
            <div className="-mx-4 my-3.5 border-t border-[#efefef]" />
            <ColorReference generator={generator} />
          </>
        )}
        <div className="-mx-4 my-3.5 border-t border-[#efefef]" />
        <h5 className="flex-1 text-[#2d2d2d] text-xs leading-[14px] font-bold font-gro">{translate('setting_size')}</h5>
        <GenerateSize generator={generator} onChange={handleSizeChange} />
        {isProMode && <HiResEntry generator={generator} />}
        <div className="-mx-4 my-3.5 border-t border-[#efefef]" />
        <h5 className="flex-1 text-[#2d2d2d] text-xs leading-[14px] font-bold font-gro">
          {translate('setting_imgnum')}
        </h5>
        <GenerateCount generator={generator} />
        {isProMode && (
          <>
            <div className="-mx-4 my-3.5 border-t border-[#efefef]" />
            <BaseParams generator={generator} />
            <div className="-mx-4 my-3.5 border-t border-[#efefef]" />
            <AddOns generator={generator} />
          </>
        )}
      </div>
    </PanelWrapper>
  );
});
